export const utils = {
  handleResponse,
  handleResponseWithFullError,
  getJsonFromUrl,
  postJsonToUrl,
  patchToUrl,
  postFileToUrl
};

function getJsonFromUrl(url, token) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "JWT " + token
    }
  };

  return fetch(url, requestOptions)
    .then(utils.handleResponse)
    .then(response => response.json());
}

function postJsonToUrl(url, body, token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "JWT " + token
    },
    body: JSON.stringify(body)
  };

  return fetch(url, requestOptions)
    .then(utils.handleResponse)
    .then(response => response);
}

function patchToUrl(url, body, token) {
  const requestOptions = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: "JWT " + token
    },
    body: JSON.stringify(body)
  };

  return fetch(url, requestOptions)
    .then(utils.handleResponse)
    .then(response => response.ok);
}

function postFileToUrl(url, email, file, token) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("user", email);
  const options = {
    method: "POST",
    headers: {
      Authorization: "JWT " + token
    },
    body: formData
  };

  return fetch(url, options)
    .then(utils.handleResponse)
    .then(status => status.ok);
}

function handleResponse(response) {
  if (!response.ok) {
    if (response.status === 401) {
      removeToken();
      location.reload(true);
    }
    const error = "Oops! Error in operation. Refresh the page and try again.";
    return Promise.reject(error);
  }
  return Promise.resolve(response);
}

function handleResponseWithFullError(response) {
  if (!response.ok) {
    if (response.status === 401) {
      removeToken();
      location.reload(true);
    }

    return Promise.reject(response);
  }

  return Promise.resolve(response);
}
